<template>
  <div class="goods-item" @click="!$store.state.app.isMobile && $emit('click')">
    <!-- 商品图片 -->
    <div class="goods-icon">
      <div class="bg" :style="{ backgroundImage: `url(${item.package.package_pic})` }"></div>
      <template v-if="checkList.indexOf('customerTag') > -1 && item.custom_tag && isFirstOrCommon">
        <!-- 不是首充类型礼包 或者是首充类型礼包且是首充加赠 -->
        <img class="tag" :src="item.custom_tag" :alt="tagAlt" />
      </template>
    </div>
    <!-- 商品信息 -->
    <div class="goods-info">
      <!-- 商品内容 -->
      <AutoFitComponent class="flex" align="center">
        <div class="goods-content bold">
          <div class="icon" :style="{ backgroundImage: `url(${item.package.main_content})` }"></div>
          <span>{{ item.package.main_number | formatPrice }}</span>
          <template
            v-if="
              item.package.other_content && item.package.other_content.length && isFirstOrCommon
            "
          >
            <div class="icon_plus"></div>
            <div
              class="icon"
              :style="{ backgroundImage: `url(${item.package.other_content[0].content})` }"
            ></div>
            <span>{{ item.package.other_content[0].count | formatPrice }}</span>
          </template>
        </div>
      </AutoFitComponent>
      <!-- 商品价格 -->
      <div
        class="goods-price medium"
        v-if="checkList.indexOf('price') > -1"
        @click.stop="$emit('click')"
      >
        <!-- 划线价 -->
        <!-- <div class="price-del" v-if="checkList.indexOf('originprice') > -1">
          {{ moneyunit + priceinit(item.package.external_amount) }}
        </div> -->
        <!-- 现价 -->
        <div
          class="price-now"
          :class="{
            paybtnnowonly: checkList.indexOf('originprice') <= -1,
          }"
        >
          {{ moneyunit }}{{ item.package.final_amount | formatPrice }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import导入组件工具等
import { mapState } from 'vuex'
export default {
  name: 'GoodsItem',
  props: {
    item: {
      type: Object,
      default: () => ({
        id: 0,
        package: {
          other_content: [],
        },
        package_type: 0,
        support_gateway: [],
        tage: '',
      }),
    },
    checkList: {
      type: Array,
      default: () => [],
    },
    moneyunit: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState({
      isFirst: (state) => state.user.isFirst,
      gameId: (state) => state.app.gameId,
      seoLang: (state) => state.app.seoLang,
    }),
    isFirstOrCommon() {
      return this.item.package_type !== 3 || this.isFirst
    },
    tagAlt() {
      const keys = this.seoLang.item_tag || []
      try {
        return keys
          .map((key) => (this.$te(key) && this.$t(key)) || '')
          .filter((msg) => !!msg)
          .join(', ')
      } catch (error) {
        return ''
      }
    },
  },
  methods: {
    priceinit(price) {
      if (price != null && price.indexOf('.') > -1) {
        price = (price * 1).toFixed(2)
      }
      if (price > 10000) {
        price = Math.ceil(price / 100) * 100
      } else if (price > 1000) {
        price = Math.ceil(price)
      }
      return price
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.goods-item {
  // width: calc((100% - 22px) / 3);
  background-color: #ffffff;
  font-size: 0;
  position: relative;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  .payall {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: block;
    margin: 0 auto 0;
  }
  .goods-icon {
    width: 100%;
    padding-top: 67.857%;
    position: relative;
    overflow: hidden;
    .bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: center;
      transition: transform 0.2s ease-in-out;
    }
    .tag {
      position: absolute;
      top: 3px;
      left: 3px;
      width: auto;
      max-width: calc(100% - 6px);
      max-height: 19px;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: center;
    }
  }
  .goods-info {
    padding: 2px 6px 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .goods-content {
      font-size: 14px;
      font-weight: 700;
      line-height: 1;
      color: rgba(33, 39, 42, 1);
      height: 34px;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      .icon {
        width: 18px;
        height: 18px;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;
        margin-right: 2px;
      }
      .icon_plus {
        width: 10px;
        height: 10.5px;
        .bg-image('icon_plus');
        margin: 0 4px;
      }
    }
    .goods-price {
      width: 100%;
      height: 32px;
      border-radius: 16px;
      background: rgba(255, 170, 0, 1);
      color: rgba(255, 255, 255, 1);
      font-size: 16px;
      font-weight: 500;
      line-height: 1;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      cursor: pointer;
      &:hover,
      &:active {
        background: rgba(235, 157, 2, 1);
      }
    }
  }
}
@media screen and (min-width: 1024px) {
  .goods-item {
    .goods-icon {
      .bg {
        &:hover {
          transform: scale(1.1);
        }
      }
    }
  }
}
</style>
